export default __webpack_public_path__ + "static/media/slider.3ecbe201.svg";